import type { ConsentParams } from '../types';

export const DEFAULT_CONSENT_OPTIONS: ConsentParams = {
  ad_personalization: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  analytics_storage: 'denied',
  // COOKIES: Leave it here in case we add these cookies in the future
  // functionality_storage: 'denied',
  // personalization_storage: 'denied',
};
